const appendStyleElement = (css, id) => {
  // First remove the existing element by ID, if it exists.
  const existing = document.querySelector(`style#${id}`);
  existing?.remove();

  if (!css) {
    // CSS is empty, so there's no reason to add an empty node.
    return;
  }

  // Then add the new element to the DOM.
  const el = document.createElement('style');
  el.id = id;
  el.innerHTML = css;
  document.head.appendChild(el);
};

export {
  appendStyleElement, // eslint-disable-line import/prefer-default-export
};
